// Internal Imports
import { RECIPIENT_DOC_BAND_TYPE_MAP } from "../../constants/document";

// Decalarations
// const UTM_PARAMS_MAP = {
//   ACCEPT_REJECT: {
//     LOGO: "utm_source=consent-logo",
//     ABOUT_REVV: "utm_source=consent-about-revv",
//   },
//   FILL_AND_ESIGN: {
//     LOGO: "utm_source=fill-esign-logo",
//     ABOUT_REVV: "utm_source=fill-esign-about-revv",
//   },
//   ESIGN: {
//     LOGO: "utm_source=esign-logo",
//     ABOUT_REVV: "utm_source=esign-about-revv",
//   },
//   SEND_TO_SOMEONE: {
//     LOGO: "utm_source=send-to-someone-logo",
//     ABOUT_REVV: "utm_source=send-to-someone-about-revv",
//   },
//   SEND_FOR_PAYMENT: {
//     LOGO: "utm_source=payment-logo",
//     ABOUT_REVV: "utm_source=payment-about-revv",
//   },
//   MAGIC_LINK: {
//     LOGO: "utm_source=magic-logo",
//     ABOUT_REVV: "utm_source=magic-about-revv",
//   },
//   WEB_FORM: {
//     LOGO: "utm_source=webform-logo",
//     ABOUT_REVV: "utm_source=webform-about-revv",
//   },
// };

export const getSharedDocStageType = (
  docStage,
  paymentStatus,
  recipientType,
  acceptingStates,
) => {
  let docStageType = null;
  // Shared document cases
  if (paymentStatus === "Paid") {
    docStageType = "SEND_FOR_PAYMENT";
  } else {
    const stageMap = docStage ? RECIPIENT_DOC_BAND_TYPE_MAP[docStage] : null;
    if (stageMap) {
      if (acceptingStates) {
        docStageType = stageMap[acceptingStates];
      } else if (recipientType) {
        docStageType = stageMap[recipientType];
      }
      if (!docStageType) {
        docStageType = "SEND_TO_SOMEONE";
      }
    } else if (!docStageType) {
      docStageType = "SEND_TO_SOMEONE";
    }
  }
  return docStageType;
};

export const getRecipientDocUtmParamsUrl = () => {
  let url = `${process.env.REACT_APP_DOMAIN_NAME}`;
  if (process.env.REACT_APP_LOGO_REDIRECTION_URL) {
    url = `${process.env.REACT_APP_LOGO_REDIRECTION_URL}`;
  } else {
    url = `https://www.legalzoom.com/`;
    // let docStageType = "";

    // if (docType === "SHARED_DOCUMENT") {
    //   docStageType = getSharedDocStageType(
    //     docStage,
    //     paymentStatus,
    //     recipientType,
    //     acceptingStates,
    //   );
    // }
    // // Magic/Perma link case
    // else if (docType === "PERMA_SHARED_DOCUMENT") {
    //   docStageType = "MAGIC_LINK";
    // } else if (docType === "MASTER_SHARED_DOCUMENT") {
    //   docStageType = "WEB_FORM";
    // }

    // const baseUtmParam = UTM_PARAMS_MAP[docStageType]
    //   ? UTM_PARAMS_MAP[docStageType][usedFor]
    //   : null;
    // if (baseUtmParam) {
    //   url = `${process.env.REACT_APP_DOMAIN_NAME}?${baseUtmParam}&utm_doc=${docName}&utm_hash=${sharingHash}`;
    // }
  }

  return url;
};
